<template>
    <div class="liveList CommentList padding-20 bgc box-shadow">
        <div class="filters">
            <div class="search">
                <el-input v-model.trim="param.customername" placeholder="评论人名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
            <div class="add">
                <el-button type="success" @click="_export">导出</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="" label="评论人名称" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img :src="scope.row.headimageurl" alt="" v-if="scope.row.headimageurl">
                            <span>{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="datetime" label="发表时间" class-name="center"></el-table-column>
                <el-table-column prop="commentusertypename" label="身份" class-name="center"></el-table-column>
                <el-table-column prop="content" label="内容" class-name="center" width="400">
                    <template slot-scope="scope">
                        <span>{{scope.row.content?scope.row.content:'--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态" class-name="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.displaystatus==0?'隐藏':'显示'}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" class-name="rightText" label-class-name="tr" width="120">
                    <template slot-scope="scope">
                        <template v-if="scope.row.commentusertype==3">
                            <span @click="wordsEvent(scope.row)">{{scope.row.iscomment==0?'解除禁言':'禁言'}}</span>
                            <span class="line">|</span>
                        </template>
                        <span @click="statusEvent(scope.row)">{{scope.row.displaystatus==0?'显示':'隐藏'}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" @getList="_getList" ref="page"></page>
        </div>
    </div>
</template>

<script>
    import {getLiveEventCommentsList,uploadCommentDisplayStatus,getExportComment,bannedVliveUser} from 'api/vliveV2Api'
    import Page from 'base/page/page'
    import {mapGetters, mapActions} from 'vuex'
    import {dateFormat} from 'common/js/tools'
    export default {
        name: "CommentList",
        data(){
            return{
                param:{
                    liveid:this.$route.query.liveid?this.$route.query.liveid:'',
                    customername:'',
                },
                total: 0,
                tableData: [],
            }
        },
        mounted(){
            this.page.page=1
            this._getList()
        },
        methods:{
            //获取评论列表
            _getList(){
                this.setLoading(true)
                getLiveEventCommentsList({
                    data: Object.assign({}, this.param,this.page),
                    success: data => {
                        this.setLoading(false)
                        this.tableData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //搜索
            handleQuery(){
                this.$refs.page.handleSizeChange(1)
            },
            //禁言/解除禁言
            wordsEvent(row){
                this.setLoading(true)
                let param={
                    commentid:row.commentid,
                    liveid:this.$route.query.liveid,
                    optype:row.iscomment==0?1:0 //0禁言 1解除禁言
                }
                bannedVliveUser({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        })
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //隐藏/显示评论信息
            statusEvent(row){
                this.setLoading(true)
                let param={
                    displaystatus:row.displaystatus==0?1:0, //0隐藏 1显示
                    innerid:row.innerid
                }
                uploadCommentDisplayStatus({
                    data: Object.assign({}, param),
                    success: data => {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '操作成功'
                        })
                        this._getList()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            //导出评论
            _export(){
                this.setLoading(true)
                getExportComment({
                    data: Object.assign({}, this.param),
                    success: data => {
                        this.setLoading(false)
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '评论列表' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
            ])
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components: {
            Page
        }
    }
</script>

<style lang="scss">
    @import "~common/scss/base";
    @import "~common/scss/mixin";
    .CommentList{
        .result-list{
            .imageText{
                display: flex;
                align-items: center;
                img{
                    min-width: 50px;
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
            .center{
                .cell{
                    text-align: center;
                }
            }
            .rightText{
                .cell{
                    text-align: right;
                    .line{
                        margin: 0 6px;
                    }
                    span{
                        color: #409EFF;
                        cursor: pointer;
                        vertical-align: baseline;
                    }
                }
            }
        }

    }
</style>
